import { render, staticRenderFns } from "./UserSupervisors.vue?vue&type=template&id=50b899c1&"
import script from "./UserSupervisors.vue?vue&type=script&lang=js&"
export * from "./UserSupervisors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports